module.exports = __webpack_public_path__ + "static/img/stamped.f35e843.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/stamped.svg
// module id = F1aN
// module chunks = 1